import TextField from 'components/text-field';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ListPermissions from './ListPermissions';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  errorText: {
    color: theme.palette.error.main,
  },
  permissionsRow: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: { marginTop: theme.spacing(1.5) },
  },
}));

const FormRole = ({ control, errors, listingQueries, listingMutations }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Controller
        name="description"
        control={control}
        render={({ field: { ref, ...field } }) => (
          <TextField
            {...field}
            inputRef={ref}
            label={t('roles:nameLabel')}
            error={!!errors.description}
            helperText={errors.description?.message || t('validations:required')}
          />
        )}
      />
      <Grid container className={classes.permissionsRow} spacing={3}>
        <Grid item xs={12} sm={6}>
          <ListPermissions
            kind="query"
            label={t('roles:informationAccessLabel')}
            control={control}
            permissions={listingQueries}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ListPermissions
            kind="mutation"
            label={t('roles:informationUpdatesLabel')}
            control={control}
            permissions={listingMutations}
          />
        </Grid>
      </Grid>
      {errors.permissions && (
        <Typography className={classes.errorText} variant="subtitle2" color="secondary">
          {errors.permissions.message}
        </Typography>
      )}
    </>
  );
};

export default FormRole;
